import React, { useState } from 'react';
import { useTranslate } from '@hooks';
import {
  Modal,
  Alert,
  Button,
  ButtonCancel,
  Input,
  FormAction,
  FormGroup,
} from '@dotone/react-ui-core';

const EmailTemplateAlertModal = ({ children, onChange, ...otherProps }) => {
  const { t, tHtml } = useTranslate('emailTemplate', 'confirmModifyModal');
  const [isOpen, setIsOpen] = useState(false);
  const [agreed, setAgreed] = useState(false);

  const handleOpen = (event) => {
    event.preventDefault();
    setAgreed(false);
    setIsOpen(true);
  };

  const handleCancel = () => {
    setAgreed(false);
    setIsOpen(false);
    if (onChange) onChange(false);
  };

  const handleProceed = () => {
    setAgreed(false);
    setIsOpen(false);
    if (onChange) onChange(true);
  };

  return (
    <>
      <a href="#" onClick={handleOpen}>
        {children}
      </a>
      <Modal
        footer={false}
        title={t('title')}
        isOpen={isOpen}
        onToggle={handleCancel}
        size="lg"
        {...otherProps}
      >
        <Alert variant="danger">{t('alert')}</Alert>
        {tHtml('content')}
        <FormGroup align="right" className="text-dark font-medium">
          <Input
            type="checkbox"
            id="emailTemplateCustomizationAgreement"
            name="emailTemplateCustomizationAgreement"
            label={t('checkbox')}
            checked={agreed}
            onChange={() => setAgreed(!agreed)}
          />
        </FormGroup>
        <hr />
        <FormAction align="right">
          <div className="mt-2">
            <Button color="primary" disabled={!agreed} onClick={handleProceed}>
              {t('submit')}
            </Button>
            <ButtonCancel onClick={handleCancel} />
          </div>
        </FormAction>
      </Modal>
    </>
  );
};

export default EmailTemplateAlertModal;
